<template>
    <div id="config">
        <header id="fi360"></header>

        <section id="start-config" class="open">
            <h1>Bonjour <strong>{{ user.last_name + ' ' + user.first_name }}</strong> ! </h1>
            <p>
                Bienvenue sur la page de configuration de votre <strong>application F.i360°</strong>.
            </p>
            <a class="btn btn-full next" id="next-trigger" @click.prevent="goToSection('add-signature')"
               href="javascript: void 0">
                <i class="icon-tool"></i>
                <span>Configurer</span>
                <i class="icon-go"></i>
            </a>
        </section> <!-- start-config -->

        <section id="add-signature">
            <h3>Ma signature</h3>
            <i class="icon-checktodo"></i>
            <p>
                Afin de pouvoir signer numériquement vos rapports d'interventions, merci d'enregistrer votre signature manuscrite
            </p>
            <a class="btn btn-full add" id="signature-trigger" @click.prevent="showModal = true">
                <span><strong>Enregistrer</strong> ma signature</span>
                <i class="icon-go"></i>
            </a>

            <signature-modal
                    v-show="showModal"
                    @close="showModal = false"
                    @signatureUpdated="saveSignature">
            </signature-modal>

        </section> <!-- add-signature add commit (bug pipeline) -->

        <section id="add-photo">
            <h3>Ma photo de profil</h3>
            <i class="icon-photo"></i>
            <p>
                Afin de bénéficier d'une interface plus personnelle merci de bien vouloir ajouter une photo de profil.
            </p>

            <form method="post" id="photoprofil" enctype="multipart/form-data">
                <input type="file" style="display: none;" accept="image/*" name="change-photo-profil" ref="inputphoto"
                       @change="savePhoto">
            </form>

            <a class="btn btn-full add" id="photo-trigger" @click.prevent="triggerPhoto" href="javascript: void 0">
                <span>Ajouter ma photo</span>
                <i class="icon-go"></i>
            </a>

            <router-link to="home" id="ignore">Pas maintenant</router-link>
        </section> <!-- add-photo -->
    </div>

</template>

<script>

    // LIBS
    import loadImage from 'blueimp-load-image'
    import localforage from 'localforage'
    // JS CLASS
    import Offline from '../../js/models/Offline'

    // COMPONENTS
    import SignatureModal from '../common/SignatureModal.vue'

    export default {

        data() {
            return {
                user: {},
                showModal: false
            }
        },

        methods: {

            goToSection(id) {
                let sections = document.querySelectorAll('#config section');
                _.each(sections, section => {
                    if (section.id === id) {
                        section.classList.add("open")
                    } else {
                        section.classList.remove("open")
                    }
                })
            },

            triggerPhoto() {
                this.$refs.inputphoto.click()
            },

            async fetchUser() {
                this.user = JSON.parse(await localforage.getItem('profil'));
                return true
            },

            async saveSignature(data) {

                let usrData = JSON.parse(await localforage.getItem('profil'));
                usrData.signature64 = data;
                await localforage.setItem('profil', JSON.stringify(usrData));
                await Offline.saveAction({action: 'update', type: 'User', id: usrData.id});

                this.goToSection('add-photo')

            },

            async savePhoto(e) {

                loadImage(
                    e.target.files[0],
                    photo => {
                        if (photo instanceof Event) {
                            swal('Erreur', 'Impossible de charger cette image, vérifiez le format du fichier.', 'error');
                            return;
                        }
                        let img = photo.toDataURL();

                        localforage
                            .getItem('profil')
                            .then(res => {

                                let usrData = JSON.parse(res);
                                usrData.photo64 = img;
                                return localforage.setItem('profil', JSON.stringify(usrData))

                            })
                            .then(() => this.$router.push('home'))
                            .catch()

                    },
                    {
                        maxWidth: 600,
                        maxHeight: 600,
                        orientation: true,
                        canvas: true
                    }
                )

            }

        },

        mounted() {

            this.fetchUser()

        },

        components: {
            SignatureModal
        }

    }

</script>



// WEBPACK FOOTER //
// Config.vue?4b7c220a